// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useNotify, Notification, defaultTheme } from "react-admin";
import * as React from "react";
import { Card, CardContent, CardActions, TextField, makeStyles, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Button, InputBase, Switch, InputLabel
} from '@material-ui/core';
import {return_form} from './index'
import { useForm,Controller } from "react-hook-form";
// utils/validators.js
export const validateIranMobile = (value: string): boolean | string => {
    const regex = /^09\d{9}$/;
    if (value) {
      if (!regex.test(value)) {
        return "شماره موبایل صحیح نمیباشد";
      }
      return true;
    }
  };
export function ReturnForm() {
    interface IFormInput {
        mobile: string;
        transactionId: string;
        canDeleteIssued:Boolean;
      }
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isValid },
      } = useForm<IFormInput>({
        mode: "onChange",
        defaultValues: {
            mobile: null,
            transactionId: null,
            canDeleteIssued:false
        },
      });
    const notify = useNotify()
      const [errorMessages, setErrorMessages] = React.useState([]);
      const [networkState, setNetworkState] = React.useState<NetworkState>("IDLE");
    
     

      const onSubmit = async (data: IFormInput) => {
        setErrorMessages([]);
        setNetworkState("PENDING");
        const postData = {
            mobile: data.mobile,
            transactionId: data.transactionId,
            canDeleteIssued:data.canDeleteIssued
        };
    
        return_form(postData).then((res)=>{
            if (res.data.err) {
                setErrorMessages([res.data.err.details.messages[0]]);
                console.log('errorMessages',errorMessages);
                
                setNetworkState("FAILED");
            }
            else{
                if (res.data) {
                    if (res.data.status === "SUCCESS") {
                      notify("     عودت با موفقیت انجام شد", { type: 'success' })
                        window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/`
                    }
               
                
                }
            }
          
          }).catch((err)=>{
            console.log('err',err);
            
          })
       
    
      
        }
   
    return (
        <Card>
         
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          margin:"3rem",
          direction: "rtl",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          {...register("mobile", {
            
          })}
          error={!!errors.mobile}
          helperText={errors.mobile ? errors.mobile.message : null}
          fullWidth
          label="شماره موبایل "
          variant="outlined"
        />
       <TextField
          {...register("transactionId", {
          })}
          error={!!errors.transactionId}
          helperText={errors.transactionId ? errors.transactionId.message : null}
          fullWidth
          label="  آی دی سفارش"
          placeholder=""
          variant="outlined"
        />
       <div style={{ display: 'flex', justifyContent: 'end', width: '100%', alignItems: 'center' }}>
       <Controller
        name="canDeleteIssued"
        control={control}
        render={({ field }) =>
        <><Switch
            {...field}
            color="primary"
            name="canDeleteIssued"
            inputProps={{ 'aria-label': 'secondary checkbox' }} /><p style={{ fontFamily: 'IranSans-Bold', fontSize: '11px' }}>کنسل کردن رژیم با وجود صادر شدن آن از سمت سیب دایت</p></>
      }
      />
       </div>
   
        <Button
          disabled={!isValid || networkState === "PENDING"}
          fullWidth
          type="submit"
          color="primary"
          variant="contained"
        >
          عودت
        </Button>

        {networkState === "SUCCEED" && <p>اطلاعات شما با موفقیت ثبت شد</p>}
        {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
        {networkState === "FAILED" &&
          (errorMessages.length > 0 ?   <p>{errorMessages[0]}</p> : <div>خطایی رخ داده است</div> )}
      </form>
   
        </Card >
    )
}